import AlertTriangleFilledIcon from '@elementor/icons/AlertTriangleFilledIcon';
import ChevronDownSmallIcon from '@elementor/icons/ChevronDownSmallIcon';
import Box from '@elementor/ui/Box';
import Typography from '@elementor/ui/Typography';
import { uxMessaging } from '@constants/ux-messaging';
import { useScannerWizardContext } from '@context/scanner-wizard-context';
import {
	StyledAccordion,
	StyledAccordionSummary,
} from '@styles/manual-fixes.styles';
import ManualFixForm from './components/manual-fix-form';

const ManualLayout = () => {
	const { openIndex, handleOpen, openedBlock, sortedViolations } =
		useScannerWizardContext();

	return (
		<Box sx={{ pb: 8 }}>
			{sortedViolations[openedBlock].map((item, index) => (
				<StyledAccordion
					key={`${item.ruleId}-${index}`}
					elevation={0}
					square
					disableGutters
					expanded={openIndex === index}
					onChange={handleOpen(index, item)}
				>
					<StyledAccordionSummary
						expandIcon={<ChevronDownSmallIcon />}
						aria-controls={`manual-panel-${index}`}
						id={`manual-panel-${index}`}
					>
						<AlertTriangleFilledIcon color="error" fontSize="small" />

						<Typography variant="body2" as="h4" noWrap>
							{uxMessaging[item.ruleId]?.violationName ?? item.category}
						</Typography>
					</StyledAccordionSummary>

					<ManualFixForm item={item} />
				</StyledAccordion>
			))}
		</Box>
	);
};

export default ManualLayout;
